import { useCallback, useState } from 'react'

export const useDirectionalIndex = (totalItems: number, initialIndex = 0) => {
  const [index, setIndex] = useState(initialIndex)
  const [direction, setDirection] = useState(1)

  const goToIndex = useCallback(
    (nextIndex: number) => {
      if (nextIndex < 0 || nextIndex >= totalItems || nextIndex === index) {
        return false
      }

      setDirection(nextIndex > index ? 1 : -1)
      setIndex(nextIndex)
      return true
    },
    [index, totalItems]
  )

  const goToNext = useCallback(() => goToIndex(index + 1), [goToIndex, index])

  return {
    index,
    direction,
    goToIndex,
    goToNext
  }
}
